import { getObjectUtil } from 'packages/src'
import getMessageErrorUtil from '../../../error/utils/get-message'

function getStatusReduxUtil (instance) {
  return getObjectUtil(instance, 'status')
}

export function getErrorReduxUtil (instance) {
  return getObjectUtil(instance, 'error')
}

export function getErrorMessageReduxUtil (instance) {
  return getMessageErrorUtil(getObjectUtil(instance, 'error'))
}

export function getErrorCodeReduxUtil (instance) {
  return getObjectUtil(instance, 'error.code')
}

export default getStatusReduxUtil
